const escapeCalendarText=(value='')=>String(value)
  .replace(/\\/g,'\\\\')
  .replace(/\r?\n/g,'\\n')
  .replace(/,/g,'\\,')
  .replace(/;/g,'\\;');

const formatCalendarDate=(date)=>{
  const [year,month,day]=date.split('-');
  return `${year}${month}${day}`;
};

const formatCalendarDateTime=(date,time)=>{
  const [year,month,day]=date.split('-');
  const [hour='00',minute='00']=time.split(':');
  return `${year}${month}${day}T${hour}${minute}00`;
};

const addFloatingHour=(value)=>{
  const year=Number(value.slice(0,4));
  const month=Number(value.slice(4,6))-1;
  const day=Number(value.slice(6,8));
  const hour=Number(value.slice(9,11));
  const minute=Number(value.slice(11,13));
  const date=new Date(Date.UTC(year,month,day,hour+1,minute));

  return [
    date.getUTCFullYear(),
    String(date.getUTCMonth()+1).padStart(2,'0'),
    String(date.getUTCDate()).padStart(2,'0'),
    'T',
    String(date.getUTCHours()).padStart(2,'0'),
    String(date.getUTCMinutes()).padStart(2,'0'),
    '00'
  ].join('');
};

export const downloadOrderCalendarEvent=(order)=>{
  if (!order?.requested_date) return;

  const date=String(order.requested_date).slice(0,10);
  const time=String(order.requested_time || '');
  const hasTime=/^\d{2}:\d{2}$/.test(time);
  const start=hasTime
    ? formatCalendarDateTime(date,time)
    : formatCalendarDate(date);
  const end=hasTime
    ? addFloatingHour(start)
    : formatCalendarDate(
      new Date(`${date}T00:00:00Z+`)
        .toISOString()
        .slice(0,10)
    );
  const orderReference=String(order.id || '').slice(0,8).toUpperCase();
  const summary=`${order.delivery_method === 'delivery' ? 'Delivery' : 'Pickup'} order ${orderReference}`;
  const itemNames=(order.items || [])
    .map((item)=>item.title)
    .filter(Boolean)
    .join(', ');
  const description=[
    `Buyer: ${order.buyer?.name || 'Customer'}`,
    `Status: ${order.status}`,
    itemNames ? `Items: ${itemNames}` : '',
    order.order_notes ? `Order notes: ${order.order_notes}` : ''
  ].filter(Boolean).join('\n');
  const dateFields=hasTime
    ? `DTSTART:${start}\r\nDTEND:${end}`
    : `DTSTART;VALUE=DATE:${start}\r\nDTEND;VALUE=DATE:${end}`;
  const content=[
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//LocalMarket//Seller Hub//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${order.id || crypto.randomUUID()}@localmarket`,
    `DTSTAMP:${new Date().toISOString().replace(/[-:]/g,'').replace(/\.\d{3}/,'')}`,
    dateFields,
    `SUMMARY:${escapeCalendarText(summary)}`,
    `DESCRIPTION:${escapeCalendarText(description)}`,
    'END:VEVENT',
    'END:VCALENDAR'
  ].join('\r\n');

  const file=new Blob([content],{type:'text/calendar;charset=utf-8'});
  const url=URL.createObjectURL(file);
  const link=document.createElement('a');

  link.href=url;
  link.download=`localmarket-order-${orderReference || 'event'}.ics`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.setTimeout(()=>URL.revokeObjectURL(url),1000);
};
